import styled from 'styled-components';

export const StyledCoachPage = styled.div`
  display: flex;
  flex-direction: column;
`;